import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const RetryRotatedIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 20),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "M4 11C4 .50001 18 1 18 9.9515 18 13 16.1 17 10.5 17"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.5 10-3.86364 2L1.5 8"
    })]
  });
};

export { RetryRotatedIcon };
//# sourceMappingURL=retry.rotated.js.map
